export enum ACCESS_REQUEST_STATUSES {
  DENIED = "Access denied",
  GRANTED = "Access granted",
  PENDING = "Access requested",
  UNREQUESTED = "Request access"
}
